import React from "react";
import Disease from "./Disease";
import NoResults from "./NoResults";
import PropTypes from "prop-types";

const DiseaseList = (props) => {
  const results = props.results;

  if (!results) {
    return false;
  }

  // Filter out items missing required link data (unless noLinks)
  // Require a name (wpTitle OR Fund_Name OR Disease) AND a permalink
  var filteredFunds = results.filter(function (fund) {
    if (props.noLinks) return true;
    var hasName =
      (fund && fund.wpTitle) ||
      (fund && fund.Fund_Name) ||
      (fund && fund.Disease);
    var hasPermalink = !!(fund && fund.permalink);
    return !!hasName && hasPermalink;
  });

  // Filter by first letter, if a letter is selected
  if (props.letter) {
    var target = String(props.letter).toUpperCase();
    filteredFunds = filteredFunds.filter(function (fund) {
      var nameSource =
        (fund && fund.wpTitle) ||
        (fund && fund.Fund_Name) ||
        (fund && fund.Disease) ||
        "";
      var first = String(nameSource)
        .trim()
        .charAt(0)
        .toUpperCase();
      return first === target;
    });
  }

  // Exclude inactive
  filteredFunds = filteredFunds.filter(function (f) {
    return !f || f.Fund_Status !== "Inactive" ? true : false;
  });

  // Sort flat by name (prefer wpTitle, then Fund_Name, then Disease)
  filteredFunds.sort(function (a, b) {
    var an = (
      (a && (a.wpTitle || a.Fund_Name || a.Disease)) || ""
    ).toLowerCase();
    var bn = (
      (b && (b.wpTitle || b.Fund_Name || b.Disease)) || ""
    ).toLowerCase();
    if (an > bn) return 1;
    if (an < bn) return -1;
    return 0;
  });

  var hasResults = filteredFunds.length > 0;

  if (!hasResults) {
    return (
      <NoResults message="Sorry, there are no disease funds associated with your search." />
    );
  }

  // FLAT RENDER (no letter headers)
  return (
    <ul class="u-richtexxt f-scale-body prospective-funds-listing">
        {filteredFunds.map(function (result, idx) {
            return (
              <li key={result.Fund_Name}>{result.Fund_Name}</li>
            );
        })}
    </ul>
  );
};

DiseaseList.propTypes = {
  letter: PropTypes.string,
  open: PropTypes.bool,
  closed: PropTypes.bool,
  reEnrollment: PropTypes.bool,
  waitListOnly: PropTypes.bool,
  displayStatus: PropTypes.bool,
  results: PropTypes.array,
  noLinks: PropTypes.bool,
};

export default DiseaseList;
